export default "__VITE_ASSET__Bad$ljos__"